var _switch;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.264 150.82l72.46 80.52a8.07 8.07 0 006 2.67h48.31c4.45 0 8.05-3.6 8.06-8.05 0-1.99-.73-3.9-2.06-5.38l-67.7-75.14 67.62-75.13c2.97-3.32 2.69-8.42-.63-11.39a8.127 8.127 0 00-5.37-2.06h-48.31c-2.28.01-4.46.97-6 2.66l-72.38 80.52c-2.75 3.07-2.75 7.72 0 10.78z",
    fill: "#5200f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.935 150.82l72.46 80.52a8.07 8.07 0 006 2.67h48.25c4.45 0 8.05-3.6 8.06-8.05 0-1.99-.73-3.9-2.06-5.38l-67.64-75.14 67.64-75.1a8.064 8.064 0 00-5.99-13.48h-48.31c-2.28.01-4.46.97-6 2.66l-72.41 80.53a8.061 8.061 0 000 10.77z",
    fill: "#5200f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseArrow);
export default __webpack_public_path__ + "static/media/collapse_arrow.ca8057db8b95e1de6bf6f9483c0381b4.svg";
export { ForwardRef as ReactComponent };